import { useHistory, useLocation } from "react-router-dom";
import { CircularProgress, Container, Step, StepLabel, Stepper, Typography } from "@mui/material";
import { useEffect } from "react";
import { RegistrationPageHeader } from "./RegistrationPageHeader";
import { useError } from "../../../hooks/useNotifications";
import { makeStyles } from "../../providers/makeStyles";
import { EmptyState } from "../EmptyState";
import { T } from "../../util/t";
import { useQuery } from "@apollo/client";
import { GET_PAYMENT_STATUS } from "../../../graphql/payment";

const useStyles = makeStyles(theme => ({
    main: {
        borderTop: `1px solid ${theme.palette.border.main}`,
        marginTop: theme.spacing(2),
        paddingTop: theme.spacing(2)
    },
    card: {
        border: `2px solid ${theme.palette.border.main}`,
        borderRadius: theme.spacing(1),
        padding: theme.spacing(2, 2, 0, 2),
        marginBottom: theme.spacing(2)
    }
}));
export const RegistrationConfirmPage = ({ apiUrl, registrationUrl, successUrl, crumbs, current, title }) => {
    const history = useHistory();
    const location = useLocation();
    const [, paymentId] = location.search.match(/paymentId=([^&]+)/) || [];
    const { notifyError } = useError();
    const classes = useStyles();
    const { data } = useQuery(GET_PAYMENT_STATUS, { variables: { id: paymentId }, pollInterval: 500 }),
        payment = data?.payment;

    useEffect(() => {
        if (!paymentId) {
            notifyError("Oops, something went wrong!");
            history.replace(registrationUrl);
        }
    }, []);

    useEffect(() => {
        if (payment) {
            if (payment.status === "success" || payment.status === "setup") {
                history.replace(successUrl, { registrationSuccessful: true });
            } else if (payment.status === "cancelled" || payment.status === "error") {
                notifyError(payment.registrationError);
                history.replace(registrationUrl);
            }
        }
    }, [payment?.status]);

    return (
        <>
            <RegistrationPageHeader crumbs={crumbs} current={current} title={title}/>
            <Container>
                <Stepper activeStep={2}>
                    <Step><StepLabel><T>Athletes</T></StepLabel></Step>
                    <Step><StepLabel><T>Your details</T></StepLabel></Step>
                    <Step><StepLabel><T>Payment</T></StepLabel></Step>
                    <Step><StepLabel><T>Done</T></StepLabel></Step>
                </Stepper>
                <main className={classes.main}>
                    <Typography variant="h7" component="h2" marginBottom={2}><T>Payment</T></Typography>
                    <section className={classes.card}>
                        <EmptyState icon={<CircularProgress/>} text="Our carrier pigeons are sending your registrations to the organiser"/>
                    </section>
                </main>
            </Container>
        </>
    );
};

